/*!
 * (C) Phonero UX - ISC License
 */
export { c as createTypographyClasses } from './createTypographyClasses-47672ee4.js';
export { c as createAnimation } from './animation-c4ed8b4f.js';
export { iosTransitionAnimation } from './ios.transition-458f86b8.js';
export { mdTransitionAnimation } from './md.transition-e181aa8b.js';
export { g as getTimeGivenProgression } from './cubic-bezier-ca07ec79.js';
export { createGesture } from './index-3cba596b.js';
export { g as getPlatforms, i as isPlatform } from './platform-1c3ea0be.js';
export { a as LIFECYCLE_DID_ENTER, c as LIFECYCLE_DID_LEAVE, L as LIFECYCLE_WILL_ENTER, b as LIFECYCLE_WILL_LEAVE, d as LIFECYCLE_WILL_UNLOAD } from './index-ccd68848.js';
export { b as actionSheetController, a as alertController, l as loadingController, m as modalController, p as popoverController, t as toastController } from './overlays-067291a8.js';
export { m as menuController } from './index-7f0985a0.js';
export { S as SIZE_TO_MEDIA, b as matchBreakpoint, a as mediaQueries, m as mediaQuerySizeToString, o as orderedMediaQueries } from './media-ff73f05c.js';
export { o as blockSwipeBackEvent, c as clamp, b as colors, a as createColorClasses, l as debounce, k as debounceEvent, n as deepReady, e as experimentalSetPuxColor, j as findItemLabel, f as format, g as getClassList, d as getClassMap, m as getElementRoot, i as hasShadowDom, h as hostContext, s as setupKeyboardListeners } from './utils-6a0516db.js';
export { V as ViewController } from './pux-nav-view-controller-a93b292a.js';
import './helpers-405b3d07.js';
import './gesture-controller-d9c2b549.js';
import './index-9ab1fbc1.js';
import './hardware-back-button-24124807.js';
import './framework-delegate-362294ab.js';

const componentMap = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  button: "button",
  body1: "p",
  body2: "p",
  subtitle1: "p",
  subtitle2: "p",
  "dialog-title": "h4",
  "item-name": "span",
  "nav-link1": "a",
  "nav-link2": "a",
  label: "label",
  "action-button1": "span",
  "action-button2": "span",
  "action-button-tiny": "span",
  "info-small": "span",
};

const slidesPresets = {
  actionButtons: {
    centerInsufficientSlides: true,
    //centeredSlides: true,
    initialSlide: 0,
    slidesPerView: 1.5,
    breakpoints: {
      340: {
        slidesPerView: 2.5,
      },
      630: {
        slidesPerView: 3.5,
      },
      768: {
        slidesPerView: 6.5,
      },
    },
  },
  simCards: {
    roundLengths: true,
    observer: true,
    watchOverflow: true,
    watchSlidesVisibility: true,
    slidesPerView: 1.1,
    spaceBetween: 5,
    centeredSlides: true,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 60,
          depth: 220,
          slideShadows: false,
          stretch: 25,
        },
      },
      640: {
        slidesPerView: 2.25,
        centeredSlides: false,
        slidesPerGroup: 2,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
      },
      768: {
        spaceBetween: 40,
        slidesPerView: 2,
        centeredSlides: false,
        slidesPerColumn: 10,
      },
    },
  },
};

function groupStringing(str, groups) {
  let tmp = "";
  let index = 0;
  let lastSep = "";
  for (const [indexOffset, sep] of groups) {
    // console.info(str, `ind '${indexOffset}' '${sep}' '${lastSep}'`)
    const newindex = index + indexOffset;
    tmp += lastSep + str.slice(index, newindex);
    index = newindex;
    lastSep = sep;
  }
  return tmp;
}
const defaultSeparatorMap = {
  noBreakingSpace: "\u00a0",
};
const groupsMap = (sepMap) => ({
  "47": {
    landline: [
      [2, sepMap.noBreakingSpace],
      [2, sepMap.noBreakingSpace],
      [2, sepMap.noBreakingSpace],
      [2, sepMap.noBreakingSpace],
    ],
    cellular: [
      [3, sepMap.noBreakingSpace],
      [2, sepMap.noBreakingSpace],
      [3, sepMap.noBreakingSpace],
    ],
  },
});
function formatTelephoneNumber(num, options = {}) {
  const { format = "no", separatorMap = defaultSeparatorMap } = options || {};
  let countryCode = "";
  let cellular = true;
  let str = String(num).replace(/\s/g, "");
  if (num.startsWith("+")) {
    countryCode = num.slice(1, 3);
    str = str.slice(3);
  }
  if (num.startsWith("0")) {
    countryCode = num.slice(2, 4);
    str = str.slice(4);
  }
  switch (format) {
    case "no":
      cellular = str[0] === "4" || str[0] === "9";
      if (!countryCode) {
        countryCode = "47";
      }
      break;
  }
  // Mobil Bredbånd numbers
  if (str.length === 12) {
    return { href: null, countryCode: null, formatted: str };
  }
  const groupsCountry = groupsMap(separatorMap)[countryCode];
  const groups = groupsCountry === null || groupsCountry === void 0 ? void 0 : groupsCountry[cellular ? "cellular" : "landline"];
  const href = `tel:+${countryCode}${str}`;
  if (groups && groups.length) {
    return { href, countryCode, formatted: groupStringing(str, groups) };
  }
  console.warn(`unknown numberFormat for number '${num}': ${format}`);
  return { href, countryCode, formatted: str };
}

export { componentMap, formatTelephoneNumber, groupStringing, slidesPresets };
